<script setup lang="ts">
import { ref } from 'vue';

import CouponIcon from '@/components/base/assets/CouponIcon.vue';
import BulkDiscountModal from '@/components/pdp/buy-block/BulkDiscountsModal.vue';
import { NutsProduct } from '@/utils/product';

defineProps<{ product: NutsProduct }>();

const isModalOpen = ref(false);
</script>

<template>
  <div
    class="flex flex-row items-center text-sm text-black font-proxima-nova"
    data-test="save-bulk-discount"
  >
    <CouponIcon
      aria-hidden="true"
      alt="coupon"
      class="self-center flex-shrink-0 object-contain w-4 h-4 mr-3 text-neutral-500"
      :size="16"
    />
    <p class="mr-2">Save when you buy in bulk</p>
    <BulkDiscountModal
      :isOpen="isModalOpen"
      :product="product"
      showB2bCTA
      @close-modal="isModalOpen = false"
      @open-modal="isModalOpen = true"
    >
      <span
        class="text-sm underline font-proxima-nova text-cyan-800"
        data-test="view-bulk-discounts"
        >View bulk discounts</span
      >
    </BulkDiscountModal>
  </div>
</template>

<style scoped>
p {
  @apply mb-0;
}
</style>
